import {
  CalculatorBodyText,
  CalculatorElevatedText,
  CalculatorInputHeadline,
  CalculatorTextCenter,
  CalculatorTextHighlight,
  CalculatorTopicHeadline,
  SliderLabel,
} from "./CalculatorTypography";
import { InputComponent, SelectorComponent } from "./CalculatorSelectInput";

import { CycleverseSlider } from "../CycleverseSlider";
import { FC } from "react";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: "50px",
  },
  isNotSectionContainer: {
    marginTop: "0px",
  },
  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: "#bababa",
  },
  dividerLabel: {
    width: "40px",
    height: "40px",
    borderRadius: "20px",
    marginTop: "-20.5px",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
  },
  input: {
    border: "none",
    height: "50px",
    borderRadius: "10px",
    marginRight: "10px",
    width: "20vw",
  },
  inputUnit: {
    fontWeight: "bold",
    fontSize: "16px",
    marginLeft: "10px",
    marginRight: "10px",
    width: "95px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      width: "45px",
    },
  },
  dividerContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
  },
  sliderContainer: {
    width: "100%",
  },
  inputImageContainer: {
    width: "100%",
    maxHeight: "200px",
    display: "flex",
    justifyContent: "center",
    marginBottom: "25px",
  },
  inputImage: {
    maxWidth: "60%",
  },

  moveItAtTheTop: {
    marginTop: "-18px",
  },
}));

const CalculatorInputSection: FC<{
  inputTitle?: any;
  inputUnite?: string;
  inputNumber?: string;
  isSelect?: boolean;
  name?: string;
  value?: any;
  onChange: any;
  inputCaption?: any;
  isSlider?: boolean;
  selectZr?: any;
  selectMinZr?: any;
  selectMaxZr?: any;
  selectMinZrLabel?: any;
  selectMaxZrLabel?: any;
  selectZrLabelUnit?: any;
  inputImageUrl?: string;
  topInputCaption?: string;
  isNotSection?: boolean;
  bottomInputCaption?: any;
  sliderStep?: number;
  isNotActive?: boolean;
  imageClass?: any;
  imageAlt?: string;
  iconColor?: string;
  captionClass?: string;
  bottomInputClass?: string;
  displayLabel?: boolean;
  sliderLabel?: string;
}> = ({
  inputTitle,
  inputUnite,
  inputNumber,
  isSelect = false,
  onChange,
  name,
  value,
  children,
  inputCaption,
  selectZr,
  selectMinZr,
  selectMaxZr,
  selectZrLabelUnit,
  isSlider,
  selectMinZrLabel,
  selectMaxZrLabel,
  inputImageUrl,
  topInputCaption,
  isNotSection,
  bottomInputCaption,
  sliderStep,
  isNotActive = false,
  imageClass = null,
  imageAlt,
  iconColor = "orange",
  captionClass,
  bottomInputClass,
  displayLabel = true,
  sliderLabel,
}) => {
  const classes = useStyles(isNotSection);
  return (
    <div className={`${classes.container} ${isNotSection ? classes.isNotSectionContainer : ""}`}>
      {!isNotSection && (
        <div className={classes.dividerContainer}>
          <div className={classes.divider}></div>
          <img
            className={classes.dividerLabel}
            src={`/images/calculators/number_icons/${iconColor}_${inputNumber}.svg`}
            alt="number"
          />
        </div>
      )}
      {inputTitle ? (
        <CalculatorInputHeadline>
          {topInputCaption && <CalculatorBodyText>{topInputCaption}</CalculatorBodyText>}
          {inputTitle}
          {inputCaption && <CalculatorBodyText className={captionClass}>{inputCaption}</CalculatorBodyText>}
        </CalculatorInputHeadline>
      ) : (
        <>{inputCaption && <CalculatorBodyText className={captionClass}>{inputCaption}</CalculatorBodyText>}</>
      )}

      {inputImageUrl && (
        <div className={classes.inputImageContainer}>
          <img
            src={inputImageUrl}
            alt={imageAlt || "input image"}
            className={`${classes.inputImage} ${imageClass || ""}`}
          />
        </div>
      )}
      {bottomInputCaption && <CalculatorBodyText className={bottomInputClass}>{bottomInputCaption}</CalculatorBodyText>}
      {isSlider ? (
        <div className={classes.sliderContainer}>
          <CalculatorElevatedText>
            <CalculatorTextCenter>
              <CalculatorTextHighlight>{selectZrLabelUnit}</CalculatorTextHighlight>
            </CalculatorTextCenter>
          </CalculatorElevatedText>
          <CycleverseSlider
            value={selectZr}
            min={selectMinZr}
            max={selectMaxZr}
            step={sliderStep || 1}
            marks={[
              { value: selectMinZr, label: selectMinZrLabel },
              { value: selectMaxZr, label: selectMaxZrLabel },
            ]}
            onChange={(_, value) => onChange(Number(value))}
            valueLabelDisplay={displayLabel ? "auto" : "off"}
            isnotactive={isNotActive}
          />
          {sliderLabel ? (
            <div className={classes?.moveItAtTheTop}>
              <CalculatorTextCenter>
                <SliderLabel>{sliderLabel}</SliderLabel>
              </CalculatorTextCenter>
            </div>
          ) : null}
        </div>
      ) : (
        <div className={classes.inputContainer}>
          <div className={classes.inputUnit} />
          {isSelect ? (
            <SelectorComponent onChange={onChange} name={name || ""} value={value || ""}>
              {children}
            </SelectorComponent>
          ) : (
            <InputComponent onChange={onChange} name={name || ""} result="" value={value || ""} />
          )}
          <div className={classes.inputUnit}>{inputUnite && inputUnite}</div>
        </div>
      )}
    </div>
  );
};

export default CalculatorInputSection;
